var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('Imprint')))]),_c('Contact')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }